module.exports = __webpack_public_path__ + "img/profilbillede.fc4ce7aa.png";